const RUM_TAG_PREFIX =
  'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf01571vpf/'

export function loadDynatraceRum(appId: string | undefined): void {
  const trimmed = appId?.trim()
  if (!trimmed) return

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.crossOrigin = 'anonymous'
  script.src = `${RUM_TAG_PREFIX}${trimmed}.js`
  document.head.appendChild(script)
}
